module.exports = __webpack_public_path__ + "img/thunderbird--enigmail.png";